"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTargetExerciseContext = void 0;
const react_1 = require("react");
const TargetExerciseContext_1 = require("@app/routes/Dashboard/components/TargetExerciseContext");
const useTargetExerciseContext = () => (0, react_1.useContext)(TargetExerciseContext_1.TargetExerciseContext);
exports.useTargetExerciseContext = useTargetExerciseContext;
